'use strict';

import store from '@/store';

const Modal = {
  confirm (text, ok, cancel) {
    let confirm = document.getElementById('confirm-modal');
    confirm.querySelector('.confirm-body').innerHTML = text;
    confirm.style.display = 'block';
    confirm.nextSibling.style.display = 'block';

    if (typeof ok === 'function') {
      store.commit('setOk', ok);
    }

    if (typeof cancel === 'function') {
      store.commit('setCancel', cancel);
    }
  }
};

export default {
  store,
  install (Vue) {
    Vue.prototype.$modal = Modal;
  }
};



// WEBPACK FOOTER //
// ./src/lib/modal.js